// Shared by every page: the cart, search, phone menu, announcement bar, rails, sign-up forms and
// page transitions. Each page entry (home.js, product.js, ...) calls boot() and then does its own part.
import { mountCart } from '../cart/index.js';
import { mountSearch } from '../ui/search.js';
import { mountMenu } from '../ui/menu.js';
import { mountAnnounce } from '../ui/announce.js';
import { mountRails } from '../ui/rail.js';
import { mountForms, siteSubscriber } from '../ui/forms.js';
import { mountTransitions } from '../ui/transitions.js';
import { mountWelcome } from '../ui/welcome.js';

export function boot() {
  const C = window.CATALOG, cfg = window.PATRONUS_SHOP || {};
  const cart = mountCart(C);
  window.SEARCH = mountSearch({ catalog: C, cart });
  mountMenu(); mountAnnounce(); mountTransitions();
  mountForms({ subscribe: siteSubscriber(), sitekey: cfg.turnstile, toast: cart.toast, offer: cfg.welcome, onCode: (code) => cart.applyCode(code) });
  if (cfg.welcome) mountWelcome({ offer: cfg.welcome });
  return { C, cart, rails: () => mountRails() };
}
